module.exports = __webpack_public_path__ + "img/9788960174269.f55c88bb.jpg";